<div [class]="'z-1 relative ' + (blockClass ? (blockClass + ' ') : '') + theme.current.card + (block.class_overwrite ? (' ' + block.class_overwrite) : '' ) + ' ' + (componentOffset) + ' mb-0'">
    <div class="container m-auto relative overflow-hidden px-3 lg:px-0">
        <app-seaweed *ngIf="block.background_seaweed" [alignment]="block.seaweed_alignment.value"
                     [theme]="theme"></app-seaweed>

        <div [class]="'mt-7 flex flex-column flex-wrap relative ' + (container ? 'md:px-6 lg:px-8 xl:!px-42' : '')">
            <app-wysiwyg [blockClass]="'[&>h1]:mb-0 [&>p]:mt-0'" [block]="block" [theme]="theme"></app-wysiwyg>

            <div class="md:block !mt-8">
                <div class="grid">
                    <ng-container *ngFor="let tile of block.blocks;">
                        <ng-container *ngIf="tile.type === 'heroTile'">
                            <div class="md:col-4">
                                <app-hero-tile [block]="tile" [theme]="theme"></app-hero-tile>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

